var _style, _g, _g2, _g3, _g4, _defs, _defs2, _g5, _defs3, _g6, _defs4, _g7, _defs5, _g8, _defs6, _g9, _g10, _g11, _defs7, _g12, _g13, _g14, _g15, _defs8, _g16, _g17, _g18, _g19, _defs9, _g20, _g21, _g22;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileyt02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    style: {
      enableBackground: "new 0 0 51 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFED00;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:none;stroke:#232323;stroke-miterlimit:10;}\r\n\t.st3{fill:#94C11A;}\r\n\t.st4{fill:#37AA33;}\r\n\t.st5{fill:#F3F2C0;}\r\n\t.st6{fill:#494949;}\r\n\t.st7{fill:#37AA33;stroke:#F3F2C0;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#494949;stroke-miterlimit:10;}\r\n\t.st9{fill:#232323;}\r\n\t.st10{fill:#FFED00;stroke:#F7F4C3;stroke-miterlimit:10;}\r\n\t.st11{opacity:0.39;}\r\n\t.st12{clip-path:url(#SVGID_2_);}\r\n\t.st13{clip-path:url(#SVGID_4_);}\r\n\t.st14{fill:none;stroke:#000000;stroke-width:0.1073;}\r\n\t.st15{clip-path:url(#SVGID_6_);}\r\n\t.st16{clip-path:url(#SVGID_8_);}\r\n\t.st17{clip-path:url(#SVGID_10_);}\r\n\t.st18{clip-path:url(#SVGID_12_);}\r\n\t.st19{clip-path:url(#SVGID_14_);}\r\n\t.st20{clip-path:url(#SVGID_16_);}\r\n\t.st21{clip-path:url(#SVGID_18_);}\r\n\t.st22{clip-path:url(#SVGID_20_);}\r\n\t.st23{clip-path:url(#SVGID_22_);}\r\n\t.st24{clip-path:url(#SVGID_24_);}\r\n\t.st25{clip-path:url(#SVGID_26_);}\r\n\t.st26{clip-path:url(#SVGID_28_);}\r\n\t.st27{clip-path:url(#SVGID_30_);}\r\n\t.st28{clip-path:url(#SVGID_32_);}\r\n\t.st29{clip-path:url(#SVGID_34_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.08
    },
    width: 575,
    height: 575,
    xlinkHref: "2E7B95F0.png",
    transform: "matrix(8.532633e-02 0 0 8.532633e-02 0.96 0.8264)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 24.7,
    cy: 24.3,
    r: 23.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.7,48.2c-13.2,0-23.9-10.7-23.9-23.9S11.5,0.4,24.7,0.4s23.9,10.7,23.9,23.9S37.9,48.2,24.7,48.2z  M24.7,1.4C12.1,1.4,1.8,11.7,1.8,24.3c0,12.6,10.3,22.9,22.9,22.9c12.6,0,22.9-10.3,22.9-22.9C47.7,11.7,37.4,1.4,24.7,1.4z"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M25.5,40.9C13.5,40.9,9,31.2,9,31.1l0.9-0.4c0,0.1,4.3,9.2,15.6,9.2c11.3,0,15.6-9.1,15.6-9.2l0.9,0.4 C42,31.2,37.4,40.9,25.5,40.9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M20.9,25.5c-0.4-0.9-1.7-3.5-2.9-3.5c-1.3,0-2.6,2.6-2.9,3.5L14,25.2c0.2-0.4,1.7-4.1,3.9-4.1 s3.7,3.7,3.9,4.1L20.9,25.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36,25.5c-0.4-0.9-1.7-3.5-2.9-3.5c-1.3,0-2.6,2.6-2.9,3.5l-0.9-0.4c0.2-0.4,1.7-4.1,3.9-4.1 c2.2,0,3.7,3.7,3.9,4.1L36,25.5z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 86.9,
    cy: 24.6,
    r: 23.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 66.2,
    y: -15.1,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45.9,
    y1: 0.1,
    x2: 66.3,
    y2: 0.1
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 66.2,
    y: 5.2,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 66.3,
    y1: 10.3,
    x2: 45.9,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45.9,
    y1: 20.4,
    x2: 66.3,
    y2: 20.4
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 66.2,
    y: 25.5,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 66.3,
    y1: 30.5,
    x2: 45.9,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45.9,
    y1: 40.7,
    x2: 66.3,
    y2: 40.7
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 66.2,
    y: 45.7,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 66.3,
    y1: 50.8,
    x2: 45.9,
    y2: 50.8
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 46,
    y: -15.1,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: 5.1,
    x2: 51,
    y2: 25.6
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45.9,
    y1: 0.1,
    x2: 66.3,
    y2: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: -15.2,
    x2: 51,
    y2: 5.3
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 25.6,
    y1: 0.1,
    x2: 46.1,
    y2: 0.1
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 46,
    y: 5.2,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: 25.4,
    x2: 51,
    y2: 45.8
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 66.3,
    y1: 10.3,
    x2: 45.9,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45.9,
    y1: 20.4,
    x2: 66.3,
    y2: 20.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: 5.1,
    x2: 51,
    y2: 25.6
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 46.1,
    y1: 10.3,
    x2: 25.6,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 25.6,
    y1: 20.4,
    x2: 46.1,
    y2: 20.4
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: -15.2,
    x2: 51,
    y2: 5.3
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: 46,
    y: 25.5,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: 45.6,
    x2: 51,
    y2: 66.1
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 66.3,
    y1: 30.5,
    x2: 45.9,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 45.9,
    y1: 40.7,
    x2: 66.3,
    y2: 40.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: 25.4,
    x2: 51,
    y2: 45.8
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 46.1,
    y1: 30.5,
    x2: 25.6,
    y2: 30.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 25.6,
    y1: 40.7,
    x2: 46.1,
    y2: 40.7
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: 5.1,
    x2: 51,
    y2: 25.6
  }))))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: 46,
    y: 45.7,
    width: 20.3,
    height: 20.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 66.3,
    y1: 50.8,
    x2: 45.9,
    y2: 50.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: 45.6,
    x2: 51,
    y2: 66.1
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 46.1,
    y1: 50.8,
    x2: 25.6,
    y2: 50.8
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st14",
    x1: 51,
    y1: 25.4,
    x2: 51,
    y2: 45.8
  })))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyt02);
export default __webpack_public_path__ + "static/media/smileyt-02.44e521b8e049ee70b47de9f360f58a7e.svg";
export { ForwardRef as ReactComponent };